module.exports = __webpack_public_path__ + "static/assets/7c47c9a3bd40cfe924c8e048bd2d80ba.svg";